import { render, staticRenderFns } from "./ItemListComponent.vue?vue&type=template&id=6622c3e2&"
import script from "./ItemListComponent.vue?vue&type=script&lang=js&"
export * from "./ItemListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports